// extracted by mini-css-extract-plugin
export default {"main":"features_main__JHXh7","list":"features_list__yX8mv"};